import React from 'react';
import { BOARD_SIZE } from '../LudoConstants';

export default function BoardSVG() {
  return (
    <svg viewBox={`0 0 ${BOARD_SIZE} ${BOARD_SIZE}`} className="ludo-svg">
      {/* Background Image */}
      <image 
        href="/assets/boards/ludo.jpg" 
        x="0" 
        y="0" 
        width={BOARD_SIZE} 
        height={BOARD_SIZE} 
        preserveAspectRatio="xMidYMid slice"
      />

      {/* Transparent Grid for Coordinate Reference (Optional for Debug) */}
      {/* 
      {Array.from({ length: BOARD_SIZE * BOARD_SIZE }).map((_, i) => (
        <rect
          key={i}
          x={i % BOARD_SIZE}
          y={Math.floor(i / BOARD_SIZE)}
          width="1"
          height="1"
          fill="transparent"
          stroke="rgba(255,255,255,0.05)"
          strokeWidth="0.01"
        />
      ))} 
      */}
    </svg>
  );
}
